module.exports = __webpack_public_path__ + "static/img/highschool.08c8317.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/memes/highschool.jpg
// module id = nwDP
// module chunks = 1